import { __spreadArrays } from "tslib";
import { POST_STATUS } from '@wix/communities-blog-universal/dist/src/constants/post';
export var ENTITY_TYPE_POSTS = 'posts';
export var ENTITY_TYPE_MANAGE_POSTS_DRAFTS = "posts-" + POST_STATUS.unpublished;
export var ENTITY_TYPE_MANAGE_POSTS_PUBLISHED = "posts-" + POST_STATUS.published;
export var ENTITY_TYPE_MANAGE_POSTS_SCHEDULED = "posts-" + POST_STATUS.scheduled;
export var ENTITY_TYPE_MANAGE_POSTS_TRASH = "posts-" + POST_STATUS.deleted;
export var ENTITY_TYPE_MANAGE_POSTS_PENDING_REVIEW = "posts-" + POST_STATUS.in_moderation;
export var ENTITY_TYPE_COMMENTS = 'comments';
export var POST_ENTITY_TYPES = [
    ENTITY_TYPE_POSTS,
    ENTITY_TYPE_MANAGE_POSTS_DRAFTS,
    ENTITY_TYPE_MANAGE_POSTS_PUBLISHED,
    ENTITY_TYPE_MANAGE_POSTS_SCHEDULED,
    ENTITY_TYPE_MANAGE_POSTS_TRASH,
    ENTITY_TYPE_MANAGE_POSTS_PENDING_REVIEW,
];
export var ALL_ENTITY_TYPES = __spreadArrays([ENTITY_TYPE_COMMENTS], POST_ENTITY_TYPES);
